// SessionExpiryAlert.tsx - Aviso global cuando la sesión está por expirar
import React, { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';

const SessionExpiryAlert: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleSessionExpiring = () => {
      setShow(true);
    };

    window.addEventListener('session-expiring', handleSessionExpiring);
    return () => window.removeEventListener('session-expiring', handleSessionExpiring);
  }, []);

  const handleLogin = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');
    window.location.href = '/login?session_expired=true';
  };

  if (!show) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[10000] flex justify-center p-4 pointer-events-none">
      <div className="bg-amber-50 border border-amber-300 rounded-2xl shadow-2xl p-4 max-w-md w-full pointer-events-auto animate-in slide-in-from-top">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-10 h-10 bg-amber-100 rounded-xl flex items-center justify-center">
            <AlertTriangle className="w-5 h-5 text-amber-600" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-amber-900 text-sm">Tu sesión ha expirado</h4>
            <p className="text-amber-700 text-xs mt-1">
              Por favor, cerrá sesión e iniciá sesión nuevamente para continuar.
            </p>
            <div className="flex gap-2 mt-3">
              <button
                onClick={handleLogin}
                className="flex items-center gap-1.5 px-4 py-2 bg-amber-600 text-white text-xs font-semibold rounded-lg hover:bg-amber-700 transition-colors"
              >
                Cerrar sesión e iniciar nuevamente
              </button>
            </div>
          </div>
          <button onClick={() => setShow(false)} className="text-amber-400 hover:text-amber-600 text-lg leading-none">&times;</button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiryAlert;
